export const ZERO_WIDTH_SPACE = '\u200b';
export const ZERO_WIDTH_JOINER = '\u200d';
